var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLeftPointingArrowPink(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3275_60451",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3275_60451)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.18654 12.7498L10.4788 16.042C10.6276 16.1908 10.701 16.3649 10.699 16.5643C10.6972 16.7636 10.6238 16.9408 10.4788 17.096C10.3238 17.251 10.1456 17.3311 9.94429 17.3363C9.74296 17.3414 9.56479 17.2664 9.40979 17.1113L4.93079 12.6325C4.75012 12.4517 4.65979 12.2408 4.65979 11.9998C4.65979 11.7588 4.75012 11.5478 4.93079 11.367L9.40979 6.88825C9.55846 6.73959 9.73504 6.66617 9.93954 6.668C10.144 6.67 10.3238 6.7485 10.4788 6.9035C10.6238 7.05867 10.6988 7.23434 10.7038 7.4305C10.709 7.62667 10.634 7.80234 10.4788 7.9575L7.18654 11.2498H18.952C19.1649 11.2498 19.343 11.3216 19.4865 11.4653C19.6302 11.6088 19.702 11.7869 19.702 11.9998C19.702 12.2126 19.6302 12.3908 19.4865 12.5343C19.343 12.6779 19.1649 12.7498 18.952 12.7498H7.18654Z",
    fill: "#FF007F"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftPointingArrowPink);
export default __webpack_public_path__ + "static/media/left-pointing-arrow-pink.a25026d792f537fc2e35026bf80f23c4.svg";
export { ForwardRef as ReactComponent };